import { createContext, useContext } from "react";

export const ClientReadOnlyContext = createContext(false);

export const useClientReadOnly = () => useContext(ClientReadOnlyContext);

// An explicit `disabled` prop always wins; otherwise inherit the nearest read-only scope.
export const useScopedDisabled = (disabledProp) => {
  const scopeReadOnly = useClientReadOnly();
  return disabledProp ?? scopeReadOnly;
};
